import { NavLink, useLocation } from "react-router-dom";
import { Home, Receipt, ArrowUpRight, CreditCard, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/app", icon: Home, label: "Home", end: true, id: "nav-home" },
  { to: "/app/activity", icon: Receipt, label: "Activity", id: "nav-activity" },
  { to: "/app/send", icon: ArrowUpRight, label: "Send", primary: true, id: "nav-send" },
  { to: "/app/cards", icon: CreditCard, label: "Cards", id: "nav-cards" },
  { to: "/app/profile", icon: User, label: "Profile", id: "nav-profile" },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isTeen = user?.family?.is_teen;
  const navItems = items.filter((i) => !(isTeen && i.id === "nav-cards"));
  return (
    <nav className="lg:hidden fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md md:max-w-lg z-40 bg-card border-t border-border shadow-[0_-6px_24px_rgba(15,23,42,0.1)]">
      <div className="flex items-stretch justify-around px-2 pt-2 pb-[max(0.6rem,env(safe-area-inset-bottom))]">
        {navItems.map(({ to, icon: Icon, label, end, primary, id }) => {
          const active = end ? pathname === to : pathname.startsWith(to);
          if (primary) {
            return (
              <NavLink key={to} to={to} data-testid={id} className="flex flex-col items-center -mt-6">
                <span className="grid place-items-center w-14 h-14 rounded-2xl text-white shadow-[0_10px_28px_rgba(75,35,204,0.45)] transition-transform duration-200 active:scale-95"
                  style={{ background: "linear-gradient(135deg,#6B3BF5,#4B23CC)" }}>
                  <Icon size={24} strokeWidth={2.4} />
                </span>
                <span className="text-[11px] mt-1 font-semibold text-primary">{label}</span>
              </NavLink>
            );
          }
          return (
            <NavLink key={to} to={to} end={end} data-testid={id}
              className="flex flex-col items-center gap-1 flex-1 py-1.5 transition-transform duration-200 active:scale-95">
              <Icon size={22} className={active ? "text-primary" : "text-muted-foreground"} strokeWidth={active ? 2.5 : 2} />
              <span className={`text-[11px] font-medium ${active ? "text-primary" : "text-muted-foreground"}`}>{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
